/**
 * Admin — Policy ritardi: la rotta storica.
 *
 * Il pannello sta in `features/working-hours/TardinessPoliciesPanel` perché lo rende anche
 * la scheda «Ritardi» di `/admin/policies` («Policy aziendali»), che è la voce di menu.
 * Questa rotta resta in piedi — è nei segnalibri e nella documentazione — e mostra lo
 * stesso pannello a pagina piena, con la sua testata.
 */
import { createFileRoute } from '@tanstack/react-router';
import { TardinessPoliciesPanel } from '@/features/working-hours/TardinessPoliciesPanel';

export const Route = createFileRoute('/_app/admin/tardiness-policies')({
  component: TardinessPoliciesPanel,
});
